// extracted by mini-css-extract-plugin
export default {"brandPromo":"iG-z","carousel":"jG-z"};